import { PaginationObject } from '../models/paginationObject';

export default {
    constructPagination: (pagination: PaginationObject) => {
        const page = pagination.offset ? pagination.offset : 0;
        return '?page=' + page + '&size=' + pagination.pageSize
    },
  };
  